import { type ComponentProps } from "react";

import { Avatar as AvatarPrimitives } from "@radix-ui/themes";
import { UserIcon } from "lucide-react";

import { type ImageTransformation, getImgUrlReplaceBe } from "@/shared.utils/image";

import { cn } from "../util.cn/cn";

interface AvatarProps
  extends Omit<ComponentProps<typeof AvatarPrimitives>, "fallback">,
  Partial<Pick<ComponentProps<typeof AvatarPrimitives>, "fallback">> {
  transformation?: ImageTransformation[];
}

const Avatar = (props: AvatarProps) => {
  const {
    fallback = <UserIcon />,
    radius = "full",
    variant = "soft",
    className,
    src,
    transformation = [{
      width: 80,
      height: 80,
      quality: 80,
    }],
    ...avatarProps
  } = props;
  return (
    <AvatarPrimitives
      {...avatarProps}
      src={src instanceof Blob
        ? src
        : getImgUrlReplaceBe({
          imgPath: src,
          transformation,
        })}
      fallback={fallback}
      radius={radius}
      variant={variant}
      className={cn("bg-white-a12", className)}
    />
  );
};

export { Avatar, type AvatarProps };
